import { render, staticRenderFns } from "./menuAssign.vue?vue&type=template&id=4aa8c602&scoped=true&"
import script from "./menuAssign.vue?vue&type=script&lang=js&"
export * from "./menuAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8c602",
  null
  
)

export default component.exports